<template>
  <div>
    <modal
      v-show="isOpen"
      :modal="isOpen"
      class="language-modal"
      @close="closeModal"
    >
      <template slot="body">
        <h4 class="modal-content-title">
          Continue to this Partou in Dutch
        </h4>
        <div class="modal-content-text">
          <p>
            Information about this Partou is only available in Dutch.
            <template v-if="venue && venue.url">
              <a
                :href="`${venue.url}`"
              >You can continue to this Partou</a> and see the pictures or read the information in Dutch.
            </template>
          </p>
          <p>You can register your child or book a tour in English. If you have any questions, please contact our customer service on <a href="tel:+31882357550">+31 (0)88 235 75 50</a>.</p>
        </div>
        <div
          v-if="venue && venue.id"
          class="btn-container is-horizontal is-aligned-to-left mt-8"
        >
          <kf-link
            :href="`/en/tour/${venue.id}`"
            class="link is-button-primary"
          >
            Request a tour
          </kf-link>

          <kf-link
            :href="`/en/registration/${venue.id}`"
            class="link is-button-secondary"
          >
            Register your child
          </kf-link>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import KfLink from '@/components/base/link/Link';
import Modal from '@/components/modal/Modal.vue';

export default {
  name: 'LanguageNotAvailableModal',
  components: {
    Modal,
    KfLink,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: () => false,
    },
    venue: {
      type: Object,
      default: () => null,
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
  }
};
</script>

<style>
  .language-modal .modal {
    @apply rounded-md;
  }

  .modal-header {
    @apply static border-0;
  }

  .modal-content-title {
    @apply text-secondary-alpha mb-4 text-2xl;
  }

  .modal-content-text a {
    @apply font-bold;
  }
</style>
